<div class="my-3 media">

    <img *ngIf="getImagePosition() == 'left'" class="d-none d-md-block align-self-center me-4"
        [src]="'../assets/imgs/' + getImageName()" [alt]="getImageText()">
    <span class="badge bg-primary bg-green d-none d-md-block button-green">{{getImageText()}}</span>

    <div class="media-body align-self-center" [innerHTML]="getInnerHTML()"> </div>

    <img *ngIf="getImagePosition() == 'right'" class="align-self-center ms-4" [src]="'../assets/imgs/' + getImageName()"
        [alt]="getImageText()">
</div>